// Mirrors Cadence.Core.Metrics.CalendarEventIds.ProviderId. Synced calendar
// events are stored as ms365_<id> / google_<id>, while the id Cadence keeps for
// an event it wrote (a focus block's externalCalendarEventId) is the provider's
// raw id — so compare the two by the provider's own id, exactly (provider ids
// are case-sensitive).
const PREFIXES = ['ms365_', 'google_'];

export function providerCalendarId(externalId: string): string {
  const prefix = PREFIXES.find((p) => externalId.startsWith(p));
  return prefix ? externalId.slice(prefix.length) : externalId;
}
